<template>
  <BuyCards v-if="showBuying" @cardsBought="play" ref="buyCardsRef" />
  <PlayCards
    v-else
    :cards2Play="cards2Play"
    :tokensWon="tokensWonE18"
    :gameStats="gameStats"
    @cardsPlayed="buy"
    ref="playCardsRef"
  />
</template>

<script>
import BuyCards from "@/components/BuyCards.vue";
import PlayCards from "@/components/PlayCards.vue";

export default {
  name: "App",
  components: { BuyCards, PlayCards },

  data() {
    return {
      cards2Play: 50,
      tokensWonE18: 0,
      gameStats: 0,

      showBuying: true,
    };
  },
  methods: {
    play: function (_cards2Play, _tokensWonE18, _gameStats) {
      console.log(_cards2Play, "cards were bought. Playing cards now");
      // console.log(_tokensWonE18, "tokens won -- gameStats=", _gameStats);
      this.cards2Play = _cards2Play;
      this.tokensWonE18 = _tokensWonE18;
      this.gameStats = _gameStats;

      this.showBuying = false;
    },

    buy: function () {
      console.log("Cards were played. Switch back to buying cards now");
      this.showBuying = true;
    },
  },
};
</script>
